import { ICommercialProduct } from 'interfaces/ICommercialProduct';
import { useCallback, useMemo } from 'react';
import { useFetch } from './useFetch';

export const useCommercialProductService = () => {
  const { callApi } = useFetch();

  const getAll = useCallback(async () => {
    const CommercialProduct = await callApi<ICommercialProduct[]>({
      url: 'CommercialProduct/GetAll',
      method: 'get',
      prefixMsgError: 'error in useUserService - getAll:'
    });

    return CommercialProduct;
  }, [callApi]);

  const get = useCallback(
    async (id: string) => {
      const sc = await callApi<ICommercialProduct>({
        url: `CommercialProduct/Get/${id}`,
        method: 'get',
        prefixMsgError: 'error in useCommercialProductService - get:'
      });

      return sc;
    },
    [callApi]
  );

  const add = useCallback(
    async (sc: ICommercialProduct) => {
      await callApi({
        url: 'CommercialProduct/Add',
        method: 'post',
        data: sc,
        prefixMsgError: 'error in useUserService - add:'
      });
    },
    [callApi]
  );

  const update = useCallback(
    async (sc: ICommercialProduct) => {
      await callApi({
        url: `CommercialProduct/Update/${sc.CommercialProductId}`,
        method: 'put',
        data: sc,
        prefixMsgError: 'error in useCommercialProductService - update:'
      });
    },
    [callApi]
  );

  return useMemo(
    () => ({
      commercialProductService: { get, getAll, add, update }
    }),
    [get, getAll, add, update]
  );
};
